<div class="sheet-header">
  <h2>{{ translationService.getComponentsText() }}</h2>
</div>

@if (groups.length) {
  @for (group of groups; track group.name) {
    <h3 class="group-title">{{ groupTitle(group.name) }}</h3>

    <table mat-table [dataSource]="group.components" class="components-table">
      <ng-container matColumnDef="componentSku">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getComponentSkuText() }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.componentSku }}</td>
      </ng-container>

      <ng-container matColumnDef="componentName">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getComponentNameText() }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.componentName }}</td>
      </ng-container>

      <ng-container matColumnDef="supplier">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getComponentSupplierText() }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.supplier || translationService.getNaText() }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getComponentQuantityText() }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
      </ng-container>

      <ng-container matColumnDef="validationStatus">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getValidationStatusText() }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span
            class="status-chip"
            [ngClass]="
              row.validationStatus === 'invalid'
                ? 'status-invalid'
                : 'status-valid'
            "
          >
            {{ statusLabel(row.validationStatus) }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="
          row.validationStatus === 'invalid' ? 'row-invalid' : 'row-valid'
        "
      ></tr>
    </table>

    <mat-divider></mat-divider>
  }
} @else {
  <p class="empty-state">{{ translationService.getNoComponentsFoundText() }}</p>
}
